var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32,
    viewBox: "0 0 40 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.921 0H.605A.59.59 0 0 0 0 .605v5.1c0 .345.26.604.605.604h24.906c.432 0 .778-.172 1.037-.432l3.546-3.543c.26-.26.432-.692.432-1.038V.605"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 6.316,
    y: 12.632,
    rx: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 6.316,
    y: 25.27,
    rx: 0.75
  })));
};
export default SvgBurger;